import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { systemLogSeverityOptionActions } from '../state/system-logs-severity-select-option.actions';
import { systemLogSeverityOptionSelectors } from '../state/system-logs-severity-select-option.reducer';
import { SystemLogSeverityOption } from '../system-logs-severity-option.interface';

@Directive({
    selector: '[ndtSystemLogSeveritySelect]',
    standalone: false
})
export class SystemLogSeveritySelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<SystemLogSeverityOption>,
      private statusService: NgrxEagerSelectService<AppState, SystemLogSeverityOption>
   ) {}

   ngAfterViewInit(): void {
      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            systemLogSeverityOptionActions,
            systemLogSeverityOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('systemLogSeverityId', this.trigger);
            },
            undefined
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
